import { UniTextDetails } from '@/design-system/components/cards';
import { ProgressStatus } from '@/design-system/components/progress';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { GetWalletsByAssetResponseWalletsItem, UserEarnDetailResponse, UserSubscriptionPreviewResponse } from '@utx/utx-client';

export interface SubscribeAssetModalProps {
  offerId: string;
  onLayout: (event: any) => void;
}

export enum SubscribeStackRoutes {
  Main = 'main',
  Confirm = 'confirm',
  Result = 'result'
}

export type SubscribeStackParamList = {
  [SubscribeStackRoutes.Main]: SubscribeAssetModalProps;
  [SubscribeStackRoutes.Confirm]: SubscribeAssetModalProps & {
    offer: UserEarnDetailResponse;
    preview: UserSubscriptionPreviewResponse;
    account: GetWalletsByAssetResponseWalletsItem;
    asset: string;
    progressCardData: Array<ProgressStatus>;
    textDetailsCardData: Array<{
      name: string;
      subText: string;
      data: string;
    }>;
    subscriptionAmount: string;
    estimatedRewardsAfterMaturity: number;
    walletId: string;
    autoRenew?: boolean;
  };
  [SubscribeStackRoutes.Result]: SubscribeAssetModalProps & {
    asset: string;
    offer: UserEarnDetailResponse;
    preview: UserSubscriptionPreviewResponse;
    offerName: string;
    subscriptionAmount: string;
    estimatedApy: number;
    progressCardData: Array<ProgressStatus>;
    textDetailsCardData: Array<UniTextDetails>;
    closeModal: () => void;
  };
};

export type SubscribeStackScreenProps<Screen extends keyof SubscribeStackParamList> = NativeStackScreenProps<
  SubscribeStackParamList,
  Screen
>;
